export const CHAT_TEMP_ID = 'temp';

export enum AUTHOR_TYPES {
  USER = 'USER',
  GPT = 'GPT',
  SYSTEM = 'SYSTEM',
  ACTION = 'ACTION',
  ERROR = 'ERROR'
}

export enum CONVERSATIONAL_MESSAGE_TYPES {
  COMMAND = 'command',
  MESSAGE = 'message_string',
  DONE = 'message_done',
  ELEMENT_RESULT = 'element_result',
  ELEMENTS_VIEW = 'elements_view',
  RATINGS_VIEW = 'ratings_view',
  SEGMENTATION_VIEW = 'segments_view',
  PROGRESS = 'progress',
  ERROR = 'error',
  REQUEST = 'request',
  ACTION_RESPONSE = 'action_response'
}

export interface ExchangeActionItem {
  text: string;
  action: (exchangeId: string) => void;
  type: ACTION_TYPES;
}

export enum ACTION_TYPES {
  CREATE_ELEMENT = 'create_element',
  BUTTON = 'button',
  TEXT = 'text_input',
  COMMAND = 'command'
}

export enum CONVERSE_ACTION_BUTTON_TYPES {
  PRIMARY = 'primary',
  SECONDARY = 'secondary'
}

export enum InnoRadarTypes{
  TECHNOLOGY = 'Technology',
  TREND = 'Trend',
}

export enum EXCHANGE_ACTIONS {
  RADAR_START = 'radar_start',
  RADAR_UPDATE = 'radar_update',// OR 'radar_display' or 'radar_refresh' or whatever
  RADAR_DETAIL = 'radar_title',
  TREND_TOPIC = 'trend_topic',
  TREND_CONFIRM = 'trend_confirm',
  TREND_REGENERATE = 'trend_regenerate',
  SEGMENT_START = 'segment',
  SEGMENT_CONFIRM = 'segment_confirm',
  SEGMENT_REGENERATE = 'segment_regenerate',
  RATE_START = 'rate',
  RATE_CONFIRM = 'rate_confirm',
  RATE_REGENERATE = 'rate_regenerate',
  RADAR_CONFIRM = 'radar_confirm',
  RADAR_REGENERATE = 'radar_regenerate',
  CREATE_ELEMENT = 'create_element',
  RATE_TOPIC = 'rate_topic',
}
